import React from "react";

const Ratings = ({ num }) => {
  return (
    <>
      <div className="rating-box">
        <div className="rating-container">
          {new Array(num).fill(parseInt(num)).map((ele, ind) => (
            <img src="/assets/images/hotel/star.svg" />
          ))}
        </div>
      </div>
    </>
  );
};

export default Ratings;
